import { FC, PropsWithChildren, useContext, createContext } from 'react';
import { Mapping } from 'api/MappingsAPI';
import { DataTypeType } from 'modules/domains';
import { useUserAndEventFields } from '../hooks/useUserAndEventFields';
import { getAggregateFieldsByDataType } from '../utils/getAggregateFieldsByDataType';

export type FieldsContextState = {
  allFields: Mapping[];
  isLoading: boolean;
  aggregateFieldsByDataType: (dataType?: DataTypeType) => Mapping[];
};

export const fieldsDefaultState: FieldsContextState = {
  allFields: [],
  isLoading: false,
  aggregateFieldsByDataType: () => [],
};

export const FieldsContext = createContext<FieldsContextState>(fieldsDefaultState);
export const useFieldsContext = () => useContext(FieldsContext);

export const FieldsContextProvider: FC<PropsWithChildren<NonNullable<unknown>>> = ({
  children,
}) => {
  const { data: allFields, isLoading } = useUserAndEventFields();
  const aggregateFieldsByDataType = getAggregateFieldsByDataType(allFields);

  return (
    <FieldsContext.Provider value={{ allFields, isLoading, aggregateFieldsByDataType }}>
      {children}
    </FieldsContext.Provider>
  );
};
